module.exports = __webpack_public_path__ + "img/puzzle_16.bf8ed433.png";